module.exports = {"TXTWCL_Sorry___an_error_has_occurred":{"id":"TXTWCL_Sorry___an_error_has_occurred","defaultMessage":"Desculpe - ocorreu um erro"}}